<template>
  <div>
    <h4>Create Promo</h4>
    <b-card>
      <b-row
        ><b-col>
          <eb-select type="text" label="label" placeholder="City"></eb-select>
        </b-col>
        <b-col> <b-form-input placeholder="TID"></b-form-input></b-col>
      </b-row>
      <b-row
        ><b-col>
          <h5>Select Order Range</h5>
          <b-row
            ><b-col md="6"
              ><p>{{ value1 }}</p>
            </b-col>
            <b-col md="6"
              ><p style="float: right">{{ max1 }}</p></b-col
            ></b-row
          >
          <b-form-input
            id="range1"
            type="range"
            min="0"
            :max="max1"
            v-model="value1"
          ></b-form-input>
        </b-col>
        <b-col>
          <h5>Select Age Group</h5>
          <b-row
            ><b-col md="6"
              ><p>{{ value2 }}</p>
            </b-col>
            <b-col md="6"
              ><p style="float: right">{{ max2 }}</p></b-col
            ></b-row
          >
          <b-form-input
            id="range2"
            type="range"
            min="0"
            :max="max2"
            v-model="value2"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row
        ><b-col>
          <h5>Select Refferal Customer</h5>
          <b-row
            ><b-col md="6"
              ><p>{{ value3 }}</p>
            </b-col>
            <b-col md="6"
              ><p style="float: right">{{ max3 }}</p></b-col
            ></b-row
          >
          <b-form-input
            id="range3"
            type="range"
            min="0"
            :max="max3"
            v-model="value3"
          ></b-form-input>
        </b-col>
        <b-col>
          <h5>Total Order Value</h5>
          <b-row
            ><b-col md="6"
              ><p>₹ {{ value4 }}</p>
            </b-col>
            <b-col md="6"
              ><p style="float: right">₹ {{ max4 }}</p></b-col
            ></b-row
          >
          <b-form-input
            id="range4"
            type="range"
            min="0"
            :max="max4"
            v-model="value4"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-checkbox v-model="influencer">Is Influencer</b-form-checkbox>
          <b-form-checkbox v-model="specialMember">Is Special Member</b-form-checkbox>
        </b-col>
      </b-row>
    </b-card>

    <b-row class="justify-content-md-center my-3">
      <b-button variant="primary" class="w-25">VIEW IMPLACTED CUSTOMER</b-button>
    </b-row>

    <b-row class="my-2">
      <b-col
        ><b-button variant="success" style="border-radius: 18px"
          >Implacted Customer(120)
          <span class="ml-3 mr-1">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span> </b-button
      ></b-col>
      <b-col>
        <b-button variant="outline-primary" style="float: right"
          ><i class="fa fa-file-text-o mx-2" aria-hidden="true"></i>Download</b-button
        >
      </b-col>
    </b-row>

    <b-card>
      <h4 class="text-primary">Promotional Configuration</h4>
      <b-row
        ><b-col>
          <eb-select type="text" label="label" placeholder="Promotion Type"></eb-select>
        </b-col>
        <b-col> <b-form-input placeholder="Promotion Amount"></b-form-input></b-col>
      </b-row>
      <b-row>
        <b-col> <b-form-input placeholder="Promotion Amount"></b-form-input></b-col>
        <b-col>
          <eb-select type="text" label="label" placeholder="Effective Date"></eb-select>
        </b-col>
      </b-row>

      <b-row class="my-2"
        ><b-col> <h5 class="text-success">Total Implacted Value Rs 3455</h5></b-col
        ><b-col>
          <b-button variant="primary" style="float: right" class="w-25"
            >SUBMIT</b-button
          ></b-col
        ></b-row
      >
    </b-card>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
export default {
  components: { ebSelect },
  data() {
    return {
      value1: 5,
      max1: 2500,
      value2: 10,
      max2: 40,
      value3: 15,
      max3: 6000,
      value4: 20,
      max4: 20000,
      influencer: false,
      specialMember: false,
    };
  },
};
</script>
<style></style>
